module.exports = __webpack_public_path__ + "static/img/rys5.cb742cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rys5.jpg
// module id = 5E7V
// module chunks = 1